import React, { useMemo } from 'react';
import { Box, Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Trending } from '@withjoy/joykit/icons';
import { ReactComponent as FireIcon } from '@apps/registry/admin/assets/fire.svg';
import { styles, StyledOptionWrapper, StyledTrendsContainer } from './TrendingSearchList.styles';
import { useRandomSearchTerms, SearchTermProps } from './TrendingSearchList.controller';
import { TOP_200_MOST_SEARCH_TERMS } from './TrendingSearchList.constants';
import { useTranslation } from '@shared/core';
import { useCatalogRegistryTelemetry } from '../../../../Catalog.telemetry';
import { getConsistentNumber } from './utils';
interface TrendingSearchListProps {
  onSelectOption: (option: string) => void;
  searchValue: string;
}

const TrendingSearchList: React.FC<TrendingSearchListProps> = ({ onSelectOption }) => {
  const { t2 } = useTranslation('catalogRegistry');
  const { coupleTrendsTitle } = t2('searchBar');
  const { displayTerms, pauseTrendingFeed, resumeTrendingFeed } = useRandomSearchTerms(TOP_200_MOST_SEARCH_TERMS);
  return (
    <StyledTrendsContainer __css={styles.trendsContainerStyles}>
      <Box>
        <Flex
          paddingX={6}
          paddingTop={5}
          paddingBottom={3}
          gap={2}
          onMouseDown={e => {
            e.preventDefault();
          }}
          onClick={e => {
            e.preventDefault();
          }}
        >
          <Flex>
            <FireIcon css={{ color: 'color(display-p3 1 0.3922 0.349)' }} />
          </Flex>
          <TextV2
            fontSize="15px"
            fontStyle="normal"
            lineHeight="140%"
            color="color(display-p3 1 0.3922 0.349)"
            typographyVariant="hed1"
            fontWeight={400}
          >
            {coupleTrendsTitle}
          </TextV2>
        </Flex>
        {displayTerms.map((suggestion: SearchTermProps) => (
          <SearchTerm
            key={suggestion.searchText}
            suggestion={suggestion.searchText}
            onSelectOption={onSelectOption}
            onMouseEnter={pauseTrendingFeed}
            onMouseLeave={resumeTrendingFeed}
          />
        ))}
      </Box>
    </StyledTrendsContainer>
  );
};

export const SearchTerm: React.FC<{ suggestion: string; onSelectOption: (option: string) => void; onMouseEnter: () => void; onMouseLeave: () => void }> = ({
  suggestion,
  onSelectOption,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { searchTrendsOptionClicked } = useCatalogRegistryTelemetry();
  const quantityOfUsersPerSearchTerm = useMemo(() => getConsistentNumber(suggestion), [suggestion]);
  const { t } = useTranslation('catalogRegistry');
  const { lastHour } = t('searchBar');
  return (
    <StyledOptionWrapper
      __css={styles.searchTermStyles}
      onMouseDown={() => {
        searchTrendsOptionClicked(suggestion);
        onSelectOption(suggestion);
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <IconV2>
        <Trending />
      </IconV2>
      <TextV2
        __css={styles.searchTermFontStyles}
        typographyVariant="body1"
      >
        {suggestion}
      </TextV2>
      <TextV2
        color="mono7"
        typographyVariant="body1"
      >
        {lastHour({ quantity: quantityOfUsersPerSearchTerm })}
      </TextV2>
    </StyledOptionWrapper>
  );
};

TrendingSearchList.displayName = 'TrendingSearchList';

export { TrendingSearchList };
